import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Achievement } from 'app/shared/services/achievement.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrls: ['./help-dialog.component.scss'],
})
export class HelpDialogComponent {
  @Input() title: string;
  @Input() achievement: Achievement;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  constructor(
    public dialogRef: MatDialogRef<HelpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private translateService: TranslateService
  ) {}

  closeHelpDialog(): void {
    this.onSelect.emit();
    this.closeDialog();
  }

  closeDialog(result?: any): void {
    this.dialogRef.close(result);
  }

  public navigateAchievementDetails(): void {
    this.closeHelpDialog();
    this.router.navigate(['stats']).then();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/achievement/components/help-dialog/help-dialog.component.ts